import {flow, getEnv, getType, types} from "mobx-state-tree";
import CodeTypeStore from "../../../stores/domain/CodeTypeStore";
import { FormattedMessage } from "react-intl";
import React from "react";
import lodash from "lodash";
import {UserModel} from "../../../models/users/userModel";
import UserStore from "../../../stores/domain/UserStore";


export const AdvancedConfFilterSelectState = types.model('AdvancedConfFilterSelectState',{
  selectStateUuid: types.maybe(types.identifier),
  userStore: types.maybe(types.late(() => types.reference(UserStore))),
  statusTypes: types.optional(types.array(types.string), []),
  fileFormat: types.optional(types.array(types.string), []),
  usage: types.optional(types.array(types.string), []),
  userEmails: types.optional(types.array(UserModel), []),
  isDisabled: types.optional(types.boolean, false),
  enableMediaFilter: types.optional(types.boolean, false),
}).volatile(self => ({
  notifySelect: types.f,
  selected: types.array,
  emails: types.array,
  tags: types.array
})).actions((self)=>({
  setIsDisabled(d) {
    self.isDisabled = d;
  },
  setFileFormat(types) {
    self.fileFormat = types
  },
  setStatusTypes(status) {
    self.statusTypes = status
  },
  setUsage(usage) {
    self.usage = usage
  },
  reset(){
    self.selected = [];
    self.setIsDisabled(false);
  },
  setEmails(emails) {
    self.emails = emails;
    self.userEmails = emails;
  },
  filterChange(data){
    self.selected = data;
    self.notifySelect(lodash.reduce(data, function(result, value, key) {
      const parts = value.value.split('.');
      const pushValue = parts[parts.length-1];
      const fieldName = value.value.substr(0, value.value.length - pushValue.length - 1 );
      (result[fieldName] || (result[fieldName] = [])).push(pushValue);
      return result;
    }, {}), ["fileFormat","status","usage", "createdBy", "modifiedBy"]);
  },
  setConsumer(f){
    self.notifySelect = f
  },
  afterCreate() {
    console.log("Instantiated " + getType(self).name)
    self.notifySelect = (data) => {
      console.log("placeholder notifySelect")
    }
  },
  setSelected(data){
    self.selected=data
  },
  setEnableMediaOptions(){
    self.enableMediaFilter=true
  },
  clearEnableMediaOptions(){
    self.enableMediaFilter=false
  }

})).views( (self) => ({
  optionValues() {
    let fileFormatOptions = [], statusOptions = [], contentOptions = [];

    if(self.enableMediaFilter && self?.fileFormat) {
      fileFormatOptions = self?.fileFormat?.slice()
        .sort((a, b) => a?.localeCompare(b))
        .flatMap((stat) => {
          return {
            label: stat,
            value: "fileFormat." + stat
          }
        });
    }
    if(self.enableMediaFilter && self?.statusTypes) {
      statusOptions = self?.statusTypes?.slice()
        .sort((a, b) => a?.localeCompare(b))
        .flatMap((stat) => {
          return {
            label: stat,
            value: "status." + stat
          }
        });
    }
    if(self.enableMediaFilter && self?.usage) {
       contentOptions = self?.usage?.slice()
        .sort((a, b) => a?.localeCompare(b))
        .flatMap((stat) => {
          return {
            label: stat,
            value: "usage." + stat
          }
        });
    }

    const userEmails = self?.userEmails || [];
    const createdByOptions = userEmails
      .slice()
      .sort((a, b) => a?.email?.localeCompare(b?.email))
      .flatMap((user) => ({
        label: user?.email,
        value: "createdBy." + user.uuid
      }));

    const modifiedByOptions = userEmails
      .slice()
      .sort((a, b) => a?.email?.localeCompare(b?.email))
      .flatMap((user) => ({
        label: user?.email,
        value: "modifiedBy." + user.uuid
      }));

    const options = [];

    if (self?.enableMediaFilter) {
      options.push({
        label: <FormattedMessage id="mediaFile.filter.filterBy.fileFormat.defaultMessage"/>,
        options: fileFormatOptions
      });
    }

    if (self?.enableMediaFilter) {
      options.push({
        label: <FormattedMessage id="mediaFile.filter.filterBy.status.defaultMessage"/>,
        options: statusOptions
      });
    }

    if (self?.enableMediaFilter) {
      options.push({
        label: <FormattedMessage id="mediaFile.filter.filterBy.usage.defaultMessage"/>,
        options: contentOptions
      });
    }

    options.push({
      label: <FormattedMessage id="listCodes.filter.filterBy.users.defaultMessage"/>,
      options: createdByOptions
    });

    options.push({
      label: <FormattedMessage id="listCodes.filter.filterBy.modifiedBy.defaultMessage"/>,
      options: modifiedByOptions
    });

    return options;
  }
}))
